import { formatString } from "@/helpers/formatting";

import { axiosClient } from "../client";
import endpoints from "../endpoints";

import type { IPaginatedResponse } from "@/models/common";
import type { StipDefinition } from "@/models/stips";

class StipsApiService {
  async getStips(params: Record<string, unknown> = {}) {
    const response = await axiosClient.get<IPaginatedResponse<StipDefinition>>(
      endpoints.STIPS.ALL,
      {
        params,
      }
    );
    return response.data;
  }

  async createStip(stip: Partial<StipDefinition>) {
    const response = await axiosClient.post<{ data: StipDefinition }>(
      endpoints.STIPS.ALL,
      stip
    );
    return response.data.data;
  }

  async updateStip(
    stipId: StipDefinition["id"],
    payload: Partial<StipDefinition>
  ) {
    const response = await axiosClient.patch<{ data: StipDefinition }>(
      formatString(endpoints.STIPS.SINGLE, stipId),
      payload
    );
    return response.data.data;
  }

  async deleteStip(stipId: StipDefinition["id"]) {
    const response = await axiosClient.delete<{ data: { deleted: boolean } }>(
      formatString(endpoints.STIPS.SINGLE, stipId)
    );
    return response;
  }
}

const stipsApiService = new StipsApiService();
export default stipsApiService;
